/* import __COLOCATED_TEMPLATE__ from './qa-monitor.hbs'; */
/* RESPONSIBLE TEAM: team-rd-services */
import Component from '@glimmer/component';

export interface MonitorNameEntry {
  id: string;
  name: string;
}

interface Signature {
  Args: {
    monitorNames: MonitorNameEntry[];
  };
}

export default class QaMonitor extends Component<Signature> {
  get primaryMonitor(): MonitorNameEntry | undefined {
    return this.args.monitorNames[0];
  }

  get additionalMonitors(): MonitorNameEntry[] {
    return this.args.monitorNames.slice(1);
  }

  get hasAdditionalMonitors(): boolean {
    return this.additionalMonitors.length > 0;
  }

  get badgeText(): string {
    return `+${this.additionalMonitors.length}`;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationsTable::TableCells::QaMonitor': typeof QaMonitor;
    'inbox2/conversations-table/table-cells/qa-monitor': typeof QaMonitor;
  }
}
